import Image, { type ImageProps } from "next/image"
import { useState } from "react"

export const ImageFallback = ({ ...props }: ImageProps) => {
    const [isVisible, setIsVisible] = useState(true)
    return isVisible && <Image {...props}
        onError={() => {
            setIsVisible(false)
        }}
        onLoadingComplete={(result) => {
            if (result.naturalWidth === 0) {
                setIsVisible(false)
            }
        }} />
}